let url = location.href;
let aboutParams = {};
	if (url.indexOf('?') !== -1) {
	  let str = url.substr(url.indexOf('?') + 1); //截取?后面的内容作为字符串
		let strs = str.split('&'); //将字符串内容以&分隔为一个数组
		for (let i = 0; i < strs.length; i++) {
			aboutParams[strs[i].split('=')[0]] = decodeURI(strs[i].split('=')[1]);
			// 将数组元素中'='左边的内容作为对象的属性名，'='右边的内容作为对象对应属性的属性值
		}
	}
	//判断是否有这个参数、而且不大于当前的盒子数量、比如现在只有三个盒子，所以不能大于3
	if(aboutParams && aboutParams.type){
		menuChange(aboutParams.type)
	}
	//点击菜单跳转到指定位置
	function menuChange(menuType){
		//定义id 
		var menuTypeId;
		switch(menuType){
		  case 'Our_Story':
		    menuTypeId = "#Our_Story";
		    break; 
		  case 'Our_History':
		    menuTypeId ="#Our_History";
		    break; 
		  case 'Company_Culture':
		    menuTypeId ="#Company_Culture";
		    break; 
		}
		//scrollTop:指定相关模块回到指定位置（该位置要去掉菜单导航栏高度）。
		if(document.getElementsByClassName(menuTypeId) && document.getElementsByClassName(menuTypeId)[0]){
			sliding(document.getElementsByClassName(menuTypeId)[0].offsetTop)
		}
	};
	// 页面滑动封装 II 兼容各浏览器、优化数学函数
	function sliding(height = 960, time = 500, step = 20) {
		// 优化height过大，代码执行需要额外的时间，导致总时长不一致
		step += Math.ceil(height / 500)
		const speed = Math.floor(time / (height / step))
		let currentPosition = document.documentElement.scrollTop || document.body.scrollTop
		window.sliding2 = setInterval(() => {
		  if (Math.abs(currentPosition - height) > step) {
		    currentPosition += currentPosition < height ? step : -step
		    window.scrollTo(0, currentPosition)
		  } else {
		    clearInterval(window.sliding2)
		  }
		}, speed)
	}